export default __webpack_public_path__ + "static/media/DNo.7-3.841b7ff3.jpg";